module.exports = __webpack_public_path__ + "img/sport_bg4.bd30ad51.png";